import React, {useEffect, useCallback, useState} from 'react';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import { useDispatch, useSelector } from 'react-redux';
import { pexios } from '../../utils/functions';
import { history } from '../../utils/variables';
import { setRouterData } from '../../redux/actions';
import EventBus from '../../components/master/eventBus';
import horn from '../../assets/audio/horn.mp3';
import circleRoad from '../../assets/images/circleRoad.png';
import VW from '../../assets/images/WV.png';
import Modal from "../../components/master/Modal";
import { useTranslation } from 'react-i18next';
import CarsGif from '../../assets/images/gifs/expert-waiting-gif.gif'
import CarsGifLight from '../../assets/images/gifs/waiting-gif.gif'

SwiperCore.use(Autoplay);
const params = {
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 5000,
    },
};

export default function ExpertWaiting() {
    const [isModalExpertShown, setIsModalExpertShown] = useState(false);
    const [cases, setCases] = useState([]);
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const {user , location , theme} = useSelector(store => store);

    //const [permission,setPermission] = useState(false)

    const goToRoute = useCallback((id, type) => {
        dispatch(setRouterData({ id, type }));
        history.push('/expert-map');
    }, [dispatch]);
    const sendLocation = useCallback((lat, lng) => {
        pexios('api/update_location', 'post', { lat, lng })
            .then(res => {
                if (res.data.length === 1) {
                    goToRoute(res.data[0].id, res.data[0].type)
                    setIsModalExpertShown(false)
                }else if (res.data.length > 1){
                    setCases(res.data || []);
                    setIsModalExpertShown(true)
                }else{
                    setIsModalExpertShown(false)
                }
            });
    }, [goToRoute]);

    useEffect(() => {
        let preventSendLocation = false;
        let time 
        //pexios('/api/change_expert_active','post',{ active: 0 });
        sendLocation(location.lat, location.lng);
        const locationWatcher = navigator.geolocation.watchPosition(info => {
            if (preventSendLocation) return;
            preventSendLocation = true;
            time = setTimeout(() => preventSendLocation = false, 30000);
            sendLocation(info.coords.latitude, info.coords.longitude);
        },
        ()=>{
            // if(!permission){
            //     toast('لطفا برای دسترسی به موقعیت تنظیمات خود را مجددا بررسی کنید','error');
            //     setTimeout(()=>setPermission(true),30000)
            // }
        }
        );
        return () => {
            navigator.geolocation.clearWatch(locationWatcher);
            clearTimeout(time)
        }
    }, [location, sendLocation]);

    function listen(data) {
        const content = data.message;
        if (content.expert_id === user.id) {
            if (content.message === 'expert_to_accident') goToRoute(content.accident_id, 'accident');
            else if (content.message === 'expert_to_register') goToRoute(content.register_id, 'register');
        }
    }

    function cancel() {
        // pexios('/api/change_expert_online', 'post', { online: 0 })
        //     .then(() => {
        //         history.replace('/');
        //     });
        history.replace('/');
    }
    function playNotification() {
        document.getElementById('notification').play();
    }

    return (
        <>
        <div className='content waiting expert'>
        <div className='waiting-gif'>
                <img src={theme === 'dark' ? CarsGif : CarsGifLight} alt="cars" />
            </div>
            {/* <EventBus onEvent={listen} /> */}
            <audio id='notification'>
                <source src={horn} type='audio/mpeg' />
            </audio>
            
            <div className='road-slider'>
                {/* <div className='road-wrapper'>
                    <img src={circleRoad} alt='circleRoad' className='circle-road' />
                    <img onClick={playNotification} src={VW} alt='WV' className='camaro' />
                </div> */}
                <div className='waiting-swiper'>
                    <div className='swiperParent' style={{width: '100%'}}>
                        <h4 dir='rtl'>{t('Dont forget')}!!</h4>
                        <Swiper {...params}>
                            <SwiperSlide>
                                {t('Check the authenticity of the vehicle')}
                            </SwiperSlide>
                            <SwiperSlide>
                                {t('Knowledge, skill, ability')}
                            </SwiperSlide>
                            <SwiperSlide>
                                {t('We are the servants of our countrymen')}
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
            <div className='text-center'>
                <button className='btn btn-orange btn-circle' onClick={cancel}>{t('End of visit')}</button>
            </div>



            {isModalExpertShown&&(
                <div className='notification-modal'>
                    <Modal visible={isModalExpertShown}>
                        {/* <i className='fas fa-times' onClick={() => setIsModalExpertShown(false)} /> */}
                        <div className='modal-content' style={{overflowY: 'auto'}}>
                        {/* <div className='close-modal'>
                        <i className='fas fa-times' onClick={() => setIsModalExpertShown(false)} />
                        </div> */}
                            <h5 className='text-center mt15 mb10' style={{borderBottom: '1px solid #eee'}}>{t('Which case do you examine?')}</h5>
                            <ul className='mt0'>
                                {
                                    cases.map((itm, index) => (
                                        <li key={index} className='d-flex align-items-center space-between'>
                                            {itm.type === 'accident' ?
                                                <span>
                                                {itm.id} -
                                                    {itm.insurance_type === 'third' ? t('Third only') : t('Body')}
                                                    ، {itm.user}
                                            </span>
                                                :
                                                <span>
                                                {itm.id} -
                                                {t('Initial visit')}
                                                ، {itm.user}
                                            </span>
                                            }

                                            <button className='btn btn-white-purple btn-sm mr15' onClick={() => goToRoute(itm.id, itm.type)}>{t('Examine')}</button>
                                        </li>
                                    ))
                                }
                            </ul>
                            <div className='text-center mb10 mt10'>
                                <button 
                                    className='btn btn-orange btn-circle' 
                                    onClick={() => {
                                    setIsModalExpertShown(false)
                                    history.replace("/")
                                }}> 
                                {t('End of visit')}
                                </button>
                            </div>
                        </div>
                    </Modal>
                </div>
            )}
        </div>
        </>
    );

}
